export default {
    vuOperationId: {
        id: 64010015
    },
    firstName: {
        id: 64010002
    },
    lastName: {
        id: 64010003
    },
    eligibleConsultant: {
        id: 64010041,
        value: 'Si'
    }
};
